
const digest = 'e6f1e80499a16cc264e2fe97a6305346231e4df86a6e39a7eb7b88cc36e35154';
const classes = {"wrapper":"_wrapper_d3o7f_1","options":"_options_d3o7f_9","leftPart":"_leftPart_d3o7f_19","rightPart":"_rightPart_d3o7f_25","icon":"_icon_d3o7f_31","text":"_text_d3o7f_35"};
const css = `._wrapper_d3o7f_1 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  font-family: "Rubik", sans-serif;
  overflow: hidden;
}
._wrapper_d3o7f_1 ._options_d3o7f_9 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  padding: 16px 24px;
  border: 1px solid #eaedf3;
  border-top: 0;
  justify-content: space-between;
}
._wrapper_d3o7f_1 ._options_d3o7f_9 ._leftPart_d3o7f_19 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
}
._wrapper_d3o7f_1 ._options_d3o7f_9 ._rightPart_d3o7f_25 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
}
._wrapper_d3o7f_1 ._options_d3o7f_9 ._rightPart_d3o7f_25 ._icon_d3o7f_31 {
  height: 20px;
  margin-right: 3px;
}
._wrapper_d3o7f_1 ._options_d3o7f_9 ._rightPart_d3o7f_25 ._text_d3o7f_35 {
  font-size: 14px;
  font-weight: 600;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  